import { ELSFlex, ELSFlexItem, ELSIcon, ELSTextBox } from 'components/common/els';
import { EDRepeatableConfig } from './constants';
import { EDRow } from './EmergencyDepartment';

export interface RepeatableRowsProps {
  config: EDRepeatableConfig;
  rows: EDRow[];
  isAuthor: boolean;
  onChange: (index: number, fieldKey: string, value: string) => void;
  onAddRow: VoidFunction;
  onDeleteRow: (index: number) => void;
}

const RepeatableRows = ({ config, rows, isAuthor, onChange, onAddRow, onDeleteRow }: RepeatableRowsProps) => (
  <div className="emergency-department__repeatable">
    <h4 className="emergency-department__section-title">{config.title}</h4>

    {rows.map((row, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <ELSFlex className="u-flex-gutter-3x emergency-department__repeatable-row" key={index} left wrap middle>
        {config.fields.map((field) => (
          <ELSFlexItem key={field.key} md="1o1" w="1o3">
            <div className="emergency-department__field">
              <label className="c-els-field__label" htmlFor={`repeatable-${config.key}-${index}-${field.key}`}>
                {field.label}
              </label>
              <ELSTextBox
                id={`repeatable-${config.key}-${index}-${field.key}`}
                value={row[field.key] ?? ''}
                isDisabled={!isAuthor}
                changeHandler={(event) => onChange(index, field.key, event?.target?.value ?? '')}
              />
            </div>
          </ELSFlexItem>
        ))}
        {isAuthor && rows.length > 1 && (
          <ELSFlexItem>
            <button type="button" className="emergency-department__repeatable-delete" aria-label={`Delete ${config.title} row ${index + 1}`} onClick={() => onDeleteRow(index)}>
              <ELSIcon name="trash" size="1x" />
            </button>
          </ELSFlexItem>
        )}
      </ELSFlex>
    ))}

    {isAuthor && (
      <button type="button" className="emergency-department__add-another" onClick={onAddRow}>
        <span className="emergency-department__add-another-text">Add Another</span>
        <ELSIcon name="add-circle" prefix="hmds" size="1x" customClass="emergency-department__add-another-icon" />
      </button>
    )}

    <div className="emergency-department__collection-divider" aria-hidden="true" />
  </div>
);

RepeatableRows.displayName = 'RepeatableRows';
export default RepeatableRows;
